const component = "section-path";

export const sectionPath = {
  component,
  sectionItem: `${component}/section-item`,
  sectionName: `${component}/section-name`,
} as const;
